export default __webpack_public_path__ + "static/media/referral_screen.5da0f3fe.svg";